
















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Emit, Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: {
    BaseButton
  }
})

export default class MoreInfoButton extends Vue {
  @Prop() loading!: boolean

  @Emit()
  moreInfoStart() {
  }
}

